import Vue from 'vue'
import App from './App.vue'
import CompositionApi from '@vue/composition-api'
import router from './router'

import VButton from '@/components/VButton.vue'
import VGame from '@/components/VGame.vue'
import VInstructions from '@/components/VInstructions.vue'
import VNextStep from '@/components/VNextStep.vue'
import VPopover from '@/components/VPopover.vue'
import VTip from '@/components/VTip.vue'
import VMultipleChoice from '@/components/VMultipleChoice.vue'
import VPuzzle from '@/components/VPuzzle.vue'
import VSlider from '@/components/VSlider.vue'
import VLeftRight from '@/components/VLeftRight.vue'
import VSort from '@/components/VSort.vue'
import VSnake from '@/components/VSnake.vue'
import VPicker from '@/components/VPicker.vue'
import VWord from '@/components/VWord.vue'

Vue.config.productionTip = false

Vue.use(CompositionApi)

Vue.component('VButton', VButton)
Vue.component('VGame', VGame)
Vue.component('VInstructions', VInstructions)
Vue.component('VNextStep', VNextStep)
Vue.component('VPopover', VPopover)
Vue.component('VTip', VTip)
Vue.component('VPuzzle', VPuzzle)
Vue.component('VMultipleChoice', VMultipleChoice)
Vue.component('VSlider', VSlider)
Vue.component('VLeftRight', VLeftRight)
Vue.component('VSort', VSort)
Vue.component('VSnake', VSnake)
Vue.component('VPicker', VPicker)
Vue.component('VWord', VWord)

/**
 * Import popovers
 */

const requireComponent = require.context('@/popovers', false, /[A-Z]\w+\.vue$/)

requireComponent.keys().forEach(fileName => {
  const key =
    fileName
      .split('/')
      .pop()
      ?.replace(/\.\w+$/, '') || ''
  Vue.component(
    key,
    requireComponent(fileName).default || requireComponent(fileName)
  )
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
